var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('div',{staticClass:"not-found-wrap text-center"},[_c('h1',{staticClass:"text-60"},[_vm._v("\n        404\n      ")]),_vm._v(" "),_c('p',{staticClass:"text-36 subheading mb-3"},[_vm._v("Error!")]),_vm._v(" "),_c('p',{staticClass:"mb-5  text-muted text-18"},[_vm._v("\n        Sorry! The page you were looking for doesn't exist.\n      ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-lg btn-primary btn-rounded",attrs:{"href":"/"}},[_vm._v("Go back to home")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./resources/assets/js/views/app/pages/notFound.vue?vue&type=template&id=48e5c130&
// module id = null
// module chunks = 